import React from "react"
import { Panel, Container, CheckBoxField, Label, TextField, Toolbar, Button, FieldSet, ComboBoxField, Image, DatePickerField, NumberField } from "@sencha/ext-modern"
import GroupCheckBox from 'tyan/components/GroupCheckBox'
import GroupRadioField from "tyan/components/GroupRadioField"
import { connect } from 'react-redux'
import { compose } from 'redux'
import Message from 'tyan/components/Message'
import { doGetInspectionDeviceInfo, doSaveInspectionDeviceInfo } from 'tyan/reducers/actions'
import { WX, getUrl } from 'tyan/public'
import { showFile, getFileIcon } from 'tyan/public/index'
import Dialog from 'tyan/components/Dialog'
import 'tyan/css/DetalApproval.css';
import TreeListView from 'tyan/components/TreeListView'
import { nullDate, equalFuns, reconfigButton } from 'tyan/public/utility'
Ext.require('Ext.MessageBox')
const style = {
  outer: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
  },
  innerContainer: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    padding: "10px",
    width: "100%",
  },
  titleContainer: {
    borderBottom: "1px solid #f5f5f5",
  },
}
class InspectionDeviceInfo extends React.Component {
  state = {
    inspectionDeviceInfo: null,
    errorMessage: null,
    saving: false,
    changeValues: null,
    contractMessage: null,
    showDialog: false,
  }

  componentDidMount = () => {
    const { doGetInspectionDeviceInfo, match: { params: { sampleInspectionID, inspectionDeviceID } } } = this.props
    let number = 'DefaultValue'
    doGetInspectionDeviceInfo({
      sampleInspectionID,
      inspectionDeviceID,
      number,
      onEnd: ({ inspectionDeviceInfo, errorMessage }) => {
        this.setState({ inspectionDeviceInfo, errorMessage })
      }
    })

  }

  getFullName = ({ item, namePrefix }) => ((namePrefix && (namePrefix + '_') || '') + (item.name || item.title))

  isEqual = (value1, value2) => (JSON.stringify(Array.isArray(value1) && value1.sort() || value1) === JSON.stringify(Array.isArray(value2) && value2.sort() || value2))

  handleBack = () => {
    const { history, match: { params: { source } } } = this.props
    Ext.toast(`执行成功！`)
    history.goBack()
  }

  handleSave = (inspectionDeviceID) => {
    const { doSaveInspectionDeviceInfo, match: { params: { sampleInspectionID } } } = this.props
    const { changeValues } = this.state
    doSaveInspectionDeviceInfo({
      sampleInspectionID,
      inspectionDeviceID,
      changeValues,
      onRequest: () => this.setState({ saving: true }),
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          this.setState({ errorMessage, saving: false })
        } else {
          this.props.history.goBack()
        }
      }
    })
  }

  //文本控件
  inputRender = ({ item, level, changeValues }) => {
    return <TextField key={item.name}
      labelAlign="left"
      labelWidth="auto"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      name={item.name}
      value={changeValues[item.name]}
      width="100%"
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
    />
  }
  handlerInputChange = ({ name, value }) => {
    const changeValues = this.getChangeValues()
    if (!this.isEqual(value, changeValues[name])) {
      let changeValuesNew = { ...changeValues, [name]: value }
      this.setState({ changeValues: changeValuesNew })
    }
  }
  //日期控件
  dateRender = ({ item, level, changeValues }) => {
    const d = item.value && item.value !== nullDate && new Date(changeValues[item.name]) || null
    const value = d && new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
    return <DatePickerField key={item.name}
      labelAlign="left"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      labelWidth="auto"
      name={item.name}
      value={value}
      width="100%"
      onChange={(obj, value) => this.handlerDateChange({ name: item.name, value })} />
  }
  handlerDateChange = ({ name, value }) => {
    const changeValues = this.getChangeValues()
    const newValue = value && Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()).valueOf()
    if (!this.isEqual(newValue, changeValues[name])) {
      this.setState({ changeValues: { ...changeValues, [name]: newValue } })
    }
  }

  //复选控件
  checkboxRender = ({ item, level }) => {
    return <GroupCheckBox key={item.name}
      margin={"0 0 0 " + (level * 28)}
      label={item.name + "：" || null}
      options={item.options}
      onCheck={obj => {
        const checked = obj.getChecked()
        const option = obj.getBoxLabel()
        const value = item.value && [...item.value] || []
        const index = value.indexOf(option)
        checked && index === -1 && value.push(option)
        !checked && index >= 0 && value.splice(index, 1)
        this.handlerInputChange({ name: item.name, value })
      }}
      checked={item.value}
    />
  }

  //单选控件
  radioRender = ({ item, level, }) => {
    return <GroupRadioField key={item.name}
      margin={"0 0 0 " + (level * 28)}
      label={item.name + "：" || null}
      options={item.options}
      onCheck={obj => this.handlerInputChange({ name: item.name, value: obj.getBoxLabel() })}
      name={item.name}
      checked={item.value}
      width="100%"
    />
  }
  //下拉控件
  dropdownlistRender = ({ item, level, changeValues }) => {
    return <ComboBoxField key={item.name}
      labelAlign="left"
      labelWidth="auto"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      options={item.options}
      anyMatch={true}
      onChange={(obj, value) => this.handlerdropdownlistChange({ name: item.name, value })}
      forceSelection
      name={item.name}
      value={changeValues[item.name]}
      width="100%"
    />
  }
  handlerdropdownlistChange = ({ name, value }) => {
    console.log('value', value)
    const { doGetInspectionDeviceInfo, match: { params: { sampleInspectionID, inspectionDeviceID } } } = this.props
    let number = ""
    if (value) {
      number = value
    }
    doGetInspectionDeviceInfo({
      sampleInspectionID,
      inspectionDeviceID,
      number,
      onEnd: ({ inspectionDeviceInfo, errorMessage }) => {
        this.setState({ inspectionDeviceInfo, errorMessage })
        let changeValuesNew = {}
        inspectionDeviceInfo && inspectionDeviceInfo.基本信息.map((item) => {
          changeValuesNew[item.name] = item.value
        })
        this.setState({ changeValues: changeValuesNew })
      }
    })
  }

  //数字控件
  numberRender = ({ item, level }) => {
    return <NumberField key={item.name}
      labelAlign="left"
      label={"<font color='black'>" + item.name + "：</font>" || null}
      labelWidth="auto"
      name={item.name}
      value={item.value}
      width="100%"
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
    />
  }

  //拍照控件
  photoRender = ({ item, level, changeValues }) => {
    return (<FieldSet key={item.name} title={item.name} labelWidth="auto" width="100%">
      <Container layout={{ type: 'vbox', pack: 'start' }} key={item.name} style={style.innerContainer} padding="0">
        {changeValues[item.name] && changeValues[item.name].map((photo, index) => (
          <Container key={'c_' + index} layout={{ type: 'hbox', align: "start", pack: "space-between" }} >
            <Button key={item.name + '_' + index} ui="confirm round" text={'照片' + (index + 1)} textAlign="left" handler={() => this.setState({ showDialog: true, path: photo.file })} />
            <i key={'i_' + index} style={style.delete} className={"fa fa-trash"} onClick={() => {
              Ext.Msg.show({
                title: "警告", message: "确定要删除吗？",
                buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
                fn: buttonID => buttonID == "ok" && this.handleDeleteImage(changeValues, item.name, index)
              })
            }}></i>
          </Container>
        ))}
      </Container>
      <Container layout={{ type: 'vbox', align: 'right' }}>
        <Button margin={"0 0 0 " + (level * 28)} ui="" text="拍照" margin="0 10 0 0" handler={() => this.handleChooseImage(changeValues, item.name)} />
      </Container>
    </FieldSet>
    )
  }

  handleChooseImage = (changeValues, name) => {
    this.setState({ changeValues: changeValues })
    WX.chooseImage({
      onChoosed: ({ file, serverId }) => {
        const { changeValues } = this.state
        !changeValues && (changeValues = {})
        !changeValues[name] && (changeValues[name] = [])
        const changeValuesNew = { ...changeValues, [name]: [...changeValues[name], { file: file, serverId: serverId }] }
        this.setState({ changeValues: changeValuesNew })
      }
    })
  }


  handleDeleteImage = (changeValues, name, index) => {
    changeValues[name].splice(index, 1)
    const changeValuesNew = { ...changeValues, [name]: [...changeValues[name]] }
    this.setState({ changeValues: changeValuesNew })
  }

  imageDialog = () => {
    const { path, showDialog } = this.state
    return (
      <Dialog
        displayed={showDialog}
        title="图片查看"
        maximizable
        bodyPadding="20"
        maxWidth="200"
        scrollable
        style='max-height: calc(100vh - 210px); overflow-y: auto;'
        defaultFocus="#ok"
        html=''
      >
        <Image mode="" src={getUrl(path)} width="100%" height="auto" scrollable />
        <Button text={'关闭'} handler={() => this.setState({ showDialog: false })} />
      </Dialog>
    )
  }

  showInspection = (inspectionDeviceInfo, changeValues) => {
    return (
      <Container layout={{ type: "vbox", align: "left" }} style={style.innerContainer} padding="0" >
        {inspectionDeviceInfo && inspectionDeviceInfo.基本信息.map((item, index) => {
          switch (item.type) {
            case "attachment":
              return (
                <Container key={index} layout={{ type: 'hbox', pack: 'start' }}>
                  <Label cls="label" key={index} html={item.name + '：'} padding="12 0 12 0" />
                  <Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + item.ext)} cls="file-button" text="详情..." height="80%" handler={() => showFile({ path: item.path, ext: item.ext })} />
                </ Container>)
            case "tree":
              return (
                <TreeListView key={item.name} data={item.children} />)
            case "logs":
              return (
                <Container layout={{ type: 'vbox', pack: 'start' }} key={index}>
                  <Label cls="label" key={index} html={item.name + '：'} />
                  {item.list && item.list.map((o, i) => (
                    <Label style={style.titleContainer} cls="label" key={i} html={o.content} padding="8 0 0 0" />
                  ))}
                </Container>
              )
            case "attachmentList":
              return (
                <Container layout={{ type: 'hbox', pack: 'start' }} key={index}>
                  <Label cls="label" key={index} html={item.name + '：'} />
                  <Container layout={{ type: 'vbox', pack: 'start', }} padding="0 0 0 10" >
                    {item.list && item.list.map((o, i) => (
                      <Container key={i} layout={{ type: 'vbox', pack: 'start', }} width="100%" padding="0 0 0 0" >
                        <Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + o.ext)} cls="file-button" text={o.file} height="80%" handler={() => showFile({ path: o.path, ext: o.ext })} />
                      </ Container>
                    )
                    )}
                  </ Container>
                </Container>
              )
            case "input":
              return (this.inputRender({ item: item, level: 0, changeValues }))
            case "date":
              return (this.dateRender({ item: item, level: 0 }))
            case "checkbox":
              return (this.checkboxRender({ item: item, level: 0 }))
            case "radio":
              return (this.radioRender({ item: item, level: 0 }))
            case "dropdownlist":
              return (this.dropdownlistRender({ item: item, level: 0, changeValues }))
            case "number":
              return (this.numberRender({ item: item, level: 0 }))
            case "photo":
              return (this.photoRender({ item: item, level: 0, changeValues }))
            default:
              return (<Label cls="label" key={index} html={item.name + '：' + item.value} padding="0 0 0 0" />)
          }
        })}
      </ Container>
    )
  }



  getChangeValues = () => {
    const { inspectionDeviceInfo, changeValues } = this.state
    if (!changeValues) {
      let changeValuesOld = {}
      inspectionDeviceInfo && inspectionDeviceInfo.基本信息.map((item) => {
        changeValuesOld[item.name] = item.value
      })
      return { ...changeValuesOld }
    }
    return { ...changeValues }
  }

  render() {
    const { inspectionDeviceInfo, errorMessage, saving } = this.state
    if (errorMessage) {
      return <Message text="错误" subtext={errorMessage} />
    } else if (!inspectionDeviceInfo) {
      return <Message text="数据加载中..." />
    }

    const changeValues = this.getChangeValues()


    const panelProps = {
      height: "100%",
      margin: "0 0 0 0",
      padding: "0 0 0 0",
    }

    return (
      <Panel shadow layout="vbox" {...panelProps}>
        <Container layout="vbox" flex={4} scrollable style={style.outer}>
          {this.showInspection(inspectionDeviceInfo, changeValues)}
        </Container>
        <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
          <Button ui="action raised" text="保存" margin="0 10 0 0" handler={() => this.handleSave(inspectionDeviceInfo.inspectionDeviceID)} disabled={saving} />
        </Toolbar>
        {this.imageDialog()}
      </Panel>
    )
  }
}

const mapStateToProps = ({ }) => ({})

export default compose(
  connect(mapStateToProps, { doGetInspectionDeviceInfo, doSaveInspectionDeviceInfo }),
)(InspectionDeviceInfo)
